import ServiceBase from "@app/shared/serviceBase";
import { authenticatedDownloadAsync } from "@app/shared/AuthenticatedDownload";

export default class ClientService extends ServiceBase {

  public async getQasUsersByActiveClientCsv(fileName?: string): Promise<void> {
    if (!!fileName && fileName.split('.').pop().toLowerCase() !== 'csv') {
      fileName += '.csv';
    }
    return await authenticatedDownloadAsync(`${window.apiEndpointV2_0}/clients/qas-users-by-active-client/csv`, null, fileName);
  }

  public async getInactiveClientsActiveLicensesCsv(fileName?: string): Promise<void> {
    if (!!fileName && fileName.split('.').pop().toLowerCase() !== 'csv') {
      fileName += '.csv';
    }
    return await authenticatedDownloadAsync(`${window.apiEndpointV2_0}/clients/inactive-clients-active-licenses/csv`, null, fileName);
  }

  public async getAccuracyAttestationLastRunCsv(fileName?: string): Promise<void> {
    if (!!fileName && fileName.split('.').pop().toLowerCase() !== 'csv') {
      fileName += '.csv';
    }
    return await authenticatedDownloadAsync(`${window.apiEndpointV2_0}/clients/accuracy-attestation-last-run/csv`, null, fileName);
  }

  public getClientHealthMetricsCsv(fileName?: string): Promise<void> {
    if (!!fileName && fileName.split('.').pop().toLowerCase() !== 'csv') {
      fileName += '.csv';
    }
    return authenticatedDownloadAsync(`${window.apiEndpointV2_0}/clients/client-health-metrics/csv`, null, fileName);
  }

  public getQuinnUtilizationCsv(fileName?: string): Promise<void> {
    if (!!fileName && fileName.split('.').pop().toLowerCase() !== 'csv') {
      fileName += '.csv';
    }
    return authenticatedDownloadAsync(`${window.apiEndpointV2_0}/clients/quinn-utilization/csv`, null, fileName);
  }


}
